export default __webpack_public_path__ + "static/media/trinitylogo.2a37a095.svg";